import React from "react";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import Tabs from "../../../Components/Common/Tabs";
import { chapterTabsData } from "../../../data/SidebarData";
import StaticPageForm from "../../../Components/Common/Forms/StaticPageForm";

const QuizBankIndex = () => {
  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={chapterTabsData} />
      <StaticPageForm title="Quiz Bank" category={"civil"} promo subscription />
    </div>
  );
};

export default QuizBankIndex;
